import { axiosObject } from "../config";

function intiateLoginWithOtp(form: any) {
  let payload = {
    type: "email",
    value: form.value.email?.toLowerCase(),
  };

  return new Promise((resolve, reject) => {
    let uri = "access/login/otp/initiate";

    axiosObject
      .post(uri, payload)
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        if (errors.response.status === 422) {
          if (errors.response.data.message === "AttributeNotVerified") {
            reject(errors.response.data);
          } else {
            form.setErrors({ email: [errors.response.data.message] });
            reject(errors.response.data.errors);
          }
        }
        reject(errors);
      });
  });
}
function loginWithOtp(form: any) {
  let payload = {
    type: "email",
    value: form.value.email,
    token: form.value.otp,
  };

  return new Promise((resolve, reject) => {
    let uri = "access/login/otp";

    axiosObject
      .post(uri, payload)
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        const res = errors.response;
        if (res?.status === 422) {
          const data = res.data;
          if (data?.message === "AttributeNotVerified") {
            reject(data);
            return;
          }
          const msg = data?.message;
          // OTP step: surface errors on `otp` (not email), same idea as mobileLoginWithOtp
          if (msg === "Invalid Token") {
            form.setErrors({ otp: ["Invalid OTP"] });
          } else {
            form.setErrors({ otp: [msg || "Verification failed"] });
          }
          reject(data?.errors ?? data);
          return;
        }
        reject(errors);
      });
  });
}

function intiateMobileLoginWithOtp(form: any) {
  let payload = {
    type: "mobile_number",
    value: "+91" + form.value.user_identity.toLocaleLowerCase(),
  };

  return new Promise((resolve, reject) => {
    let uri = "access/login/otp/initiate";

    axiosObject
      .post(uri, payload)
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        if (errors.response.status === 422) {
          if (errors.response.data.message === "AttributeNotVerified") {
            form.setErrors({ user_identity: ["User is not verified"] });
            reject(errors.response.data);
          } else if (
            errors.response.data.message === "AttributeNotRegistered"
          ) {
            form.setErrors({ user_identity: ["User is not registered"] });
            reject(errors.response.data);
          } else {
            form.setErrors({
              user_identity: [errors?.response?.data?.message],
            });
            reject(errors?.response?.data?.errors);
          }
        }
        reject(errors);
      });
  });
}
function mobileLoginWithOtp(form: any) {
  let payload = {
    type: "mobile_number",
    value: "+91" + form.value.user_identity.toLocaleLowerCase(),
    token: form.value.token,
  };

  return new Promise((resolve, reject) => {
    let uri = "access/login/otp";

    axiosObject
      .post(uri, payload)
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        if (errors.response.status === 422) {
          if (errors.response.data.message === "Invalid Token") {
            form.setErrors({ token: ["Invalid OTP"] });
            reject(errors.response.data);
          } else {
            form.setErrors({ token: [errors.response.data.message] });
            reject(errors.response.data.errors);
          }
        }
        reject(errors);
      });
  });
}

function intiateEmailLoginWithOtp(form: any) {
  let payload = {
    type: "email",
    value: form.value.user_identity.toLocaleLowerCase(),
  };

  return new Promise((resolve, reject) => {
    let uri = "access/login/otp/initiate";

    axiosObject
      .post(uri, payload)
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        if (errors.response.status === 422) {
          if (errors.response.data.message === "AttributeNotVerified") {
            form.setErrors({ user_identity: ["User is not verified"] });
            reject(errors.response.data);
          } else if (
            errors.response.data.message === "AttributeNotRegistered"
          ) {
            form.setErrors({ user_identity: ["User is not registered"] });
            reject(errors.response.data);
          } else {
            form.setErrors({
              user_identity: [errors?.response?.data?.message],
            });
            reject(errors?.response?.data?.errors);
          }
        }
        reject(errors);
      });
  });
}
function emailLoginWithOtp(form: any) {
  let payload = {
    type: "email",
    value: form.value.user_identity.toLocaleLowerCase(),
    token: form.value.token,
  };

  return new Promise((resolve, reject) => {
    let uri = "access/login/otp";

    axiosObject
      .post(uri, payload)
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        if (errors.response.status === 422) {
          if (errors.response.data.message === "Invalid Token") {
            form.setErrors({ token: ["Invalid OTP"] });
            reject(errors.response.data);
          } else {
            form.setErrors({ token: [errors.response.data.message] });
            reject(errors.response.data.errors);
          }
        }
        reject(errors);
      });
  });
}

function addAttribute(data: any, form: any) {
  return new Promise((resolve, reject) => {
    let uri = `access/update-attribute`;
    let payload = {
      type: data.type,
      value: data.value.toLocaleLowerCase(),
    };
    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        if (errors.response.status === 422) {
          if (
            errors.response.data.errors.value[0] === "Value should be unique"
          ) {
            if (data.type === "email") {
              form.setErrors({ email: ["Email already registered"] });
            } else {
              form.setErrors({
                mobile_number: ["Mobile number already registered"],
              });
            }
            reject(errors.response.data.errors);
          } else {
            reject(errors.response.data.errors);
          }
        }
        reject(errors);
      });
  });
}

function verifyAttribute(form: any) {
  return new Promise((resolve, reject) => {
    let uri = `access/verify-attribute`;
    let payload = {
      type: form.value.type,
      value: form.value.value.toLocaleLowerCase(),
      token: form.value.token,
    };
    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        if (errors.response.status === 422) {
          if (errors?.response?.data?.message === "Invalid Token") {
            form.setErrors({ token: ["Invalid OTP"] });
            reject(errors.response.data);
          } else if (
            errors?.response?.data?.message === "AttributeAlreadyExist"
          ) {
            form.setErrors({ token: ["Mobile already registered"] });
            reject(errors.response.data);
          } else if (
            errors?.response?.data?.errors?.value[0] === "Invalid Token"
          ) {
            form.setErrors({ token: ["Invalid OTP"] });
            reject(errors.response.data);
          } else {
            form.setErrors({ token: [errors.response.data.message] });
            reject(errors.response.data.errors);
          }
        }
        reject(errors);
      });
  });
}

export {
  intiateLoginWithOtp,
  loginWithOtp,
  intiateMobileLoginWithOtp,
  mobileLoginWithOtp,
  intiateEmailLoginWithOtp,
  emailLoginWithOtp,
  addAttribute,
  verifyAttribute,
};
